'use client'

import { useEffect } from 'react';
import Script from 'next/script';

const NewRelicBrowserMonitoring = () => {
  // Add fallback values for New Relic credentials
  const newRelicAccountId = process.env.NEXT_PUBLIC_NEWRELIC_ACCOUNT_ID || '6627279';
  const newRelicAppId = process.env.NEXT_PUBLIC_NEWRELIC_APP_ID || 'fintechtoronto';
  const newRelicLicenseKey = process.env.NEXT_PUBLIC_NEWRELIC_LICENSE_KEY || 'cb70b8dba2671d5951a0f1b0c548cbadFFFFNRAL';

  return (
    <>
      <Script id="newrelic-browser-agent" strategy="beforeInteractive">
        {`
        ;window.NREUM||(NREUM={});NREUM.init={distributed_tracing:{enabled:true},privacy:{cookies_enabled:true}};
        ;(function(NREUM){NREUM.info={beacon:"bam.nr-data.net",errorBeacon:"bam.nr-data.net",licenseKey:"${newRelicLicenseKey}",applicationID:"${newRelicAppId}",sa:1}})();
        `}
      </Script>
      <Script
        id="newrelic-browser-script"
        src={`https://js-agent.newrelic.com/nr-spa-${newRelicAccountId}.min.js`}
        strategy="beforeInteractive"
      />
    </>
  );
};

export default NewRelicBrowserMonitoring; 